import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#364153",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.333",
      d: "M13.333 6.667c0 3.328-3.692 6.795-4.932 7.866a.67.67 0 0 1-.802 0c-1.24-1.071-4.932-4.538-4.932-7.866a5.333 5.333 0 1 1 10.666 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#364153",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.333",
      d: "M8 8.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    }, null, -1)
  ])))
}
export default { render: render }